






import Vue from 'vue'
import { Component } from '@niknevis/vue-modules'
import { Prop } from 'vue-property-decorator'

@Component({
  inheritAttrs: false,
  components: {}
})
export default class TextWrapper extends Vue {
  @Prop({ default: '' }) text!: string
  @Prop({ default: '' }) emptyText!: string
  @Prop({ default: null }) width!: number

  style = {
    display: 'inline-block',
    width: `${this.width}px !important`,
    wordWrap: 'break-word',
    wordBreak: 'break-all',
    whiteSpace: 'pre-wrap !important'
  }

}
